import {ShortcutItemVo} from '../../common/shared/api/gateway/shortcut/ShortcutItemVo.interface';
import {ShortcutItem} from '../generated/types';

export function createShortcutItem({
  title,
  scheme,
  icon,
}: ShortcutItemVo): ShortcutItem {
  return {
    title,
    scheme,
    icon,
  };
}
